<form [formGroup]="chargeForm">
    <div class="col-md-12">
        <div class="row">
            <div class="col-md-12 table-container">
                <div class="table-responsive">
                    <table class="table table-bordered table-sm m-0">
                        <thead class="table-light">
                            <tr>
                                <th>#</th>
                                <th>Contract Charges</th>
                                <th>Other Charges</th>
                                <th>Sub Total</th>
                                <th>Total Fuel</th>
                                <th>IGST</th>
                                <th>CGST</th>
                                <th>SGST</th>
                                <th>Total Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <label for="summary" class="form-label"
                                        style="display: block; text-align: center;"><b>Summary</b></label>
                                </td>
                                <td>
                                    <span class="customspan"> {{getFields("txtContractCharges")}}</span>
                                </td>
                                <td>
                                    <span class="customspan"> {{getFields("txtOtherCharges")}}</span>
                                </td>
                                <td>
                                    <span class="customspan">{{getFields("txtSubTotal")}}</span>
                                </td>
                                <td>
                                    <span class="customspan"> {{getFields("txtTotalFuel")}}</span>
                                </td>
                                <td>
                                    <span class="customspan"> {{getFields("txtIGST")}}</span>
                                </td>
                                <td>
                                    <span class="customspan"> {{getFields("txtCGST")}}</span>
                                </td>
                                <td>
                                    <span class="customspan"> {{getFields("txtSGST")}}</span>
                                </td>
                                <td>
                                    <span class="customspan"> {{getFields("txtTotalAmount")}}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="row mt-3" formGroupName="chargesdetails">
            <div class="col-md-2">
                <div class="mb-2">
                    <label for="description" class="form-label">Description<span class="mandatory">*</span></label>
                    <ng-select #description [items]="chargesOptions" bindLabel="name" [bindValue]="'id'" id="description"
                        formControlName="txtDescription" (change)="calculateFuelTax($event, true, false);" placeholder="Select"
                        [appendTo]="'body'" [openOnEnter]="false"
                        [ngClass]="{'is-invalid':(formSubmitted || chargeForm.get('chargesdetails.txtDescription')?.touched) && chargeForm.get('chargesdetails.txtDescription').errors}"
                        (keydown.enter)="useEnterKey && chargeForm.get('chargesdetails.txtDescription').valid ? (this.validateRateFields() && itemamount.focus()) : chargeForm.get('chargesdetails.txtDescription').markAsTouched()">
                    </ng-select>
                    <div *ngIf="(formSubmitted || chargeForm.get('chargesdetails.txtDescription')?.touched) && chargeForm.get('chargesdetails.txtDescription').errors"
                        class="invalid-feedback">
                        <span *ngIf="chargeForm.get('chargesdetails.txtDescription').errors.required">
                            Description is Required.
                        </span>
                    </div>
                </div>
            </div>

            <div class="col-md-1">
                <div class="mb-2">
                    <label for="itemamount" class="form-label">Item Amount<span class="mandatory">*</span></label>
                    <input #itemamount type="number" class="form-control form-control-sm" id="itemamount"
                        formControlName="txtItemAmount" (change)="calculateFuelTax(null, false, false)"
                        (keydown)="preventWrongInput($event)"
                        [ngClass]="{'is-invalid':(formSubmitted ||chargeForm.get('chargesdetails.txtItemAmount')?.touched) && chargeForm.get('chargesdetails.txtItemAmount').errors}" 
                        (keydown.enter)="useEnterKey && chargeForm.get('chargesdetails.txtItemAmount').valid ? btnfuelradio1.focus() : chargeForm.get('chargesdetails.txtItemAmount').markAsTouched()"/>
                    <div *ngIf="(formSubmitted || chargeForm.get('chargesdetails.txtItemAmount')?.touched) && chargeForm.get('chargesdetails.txtItemAmount').errors"
                        class="invalid-feedback">
                        <span *ngIf="chargeForm.get('chargesdetails.txtItemAmount').errors.pattern">
                            Please enter a number with up to 12 digits and at most three decimal places.
                        </span>
                    </div>
                    <div *ngIf="(formSubmitted || chargeForm.get('chargesdetails.txtItemAmount')?.touched) && chargeForm.get('chargesdetails.txtItemAmount').errors"
                        class="invalid-feedback">
                        <span *ngIf="chargeForm.get('chargesdetails.txtItemAmount').errors.required">
                            Item Amount is Required
                        </span>
                    </div>
                </div>
            </div>

            <div class="col-md-1">
                <div class="mb-2">
                    <label for="itemfuel" class="form-label">Item Fuel &nbsp;</label>
                    <div role="group" aria-label="Item fuel" class="btn-group btn-group-sm d-flex">
                        <input #btnfuelradio1 type="radio" id="btnfuelradio1" autocomplete="off" checked="" class="btn-check"
                            value="Yes" (change)="calculateFuelTax(null, false, true)" formControlName="chkItemFuel" 
                            (keydown.enter)="useEnterKey && btnfuelradio2.focus()"/>
                        <label for="btnfuelradio1" class="btn btn-outline-secondary">Yes</label>
                        <input #btnfuelradio2 type="radio" id="btnfuelradio2" autocomplete="off" class="btn-check" value="No"
                            (change)="calculateFuelTax(null, false, true)" formControlName="chkItemFuel" 
                            (keydown.enter)="useEnterKey && btnradio1.focus()"/>
                        <label for="btnfuelradio2" class="btn btn-outline-secondary">No</label>
                    </div>
                </div>
            </div>

            <div class="col-md-1">
                <div class="mb-2">
                    <label for="fuelamt" class="form-label">Fuel Amt</label>
                    <input #fuelamt type="number" class="form-control form-control-sm" id="fuelamt" formControlName="txtFuelAmt" />
                    <!-- <div *ngIf="(formSubmitted || chargeForm.get('chargesdetails.txtFuelAmt')?.touched) && chargeForm.get('chargesdetails.txtFuelAmt').errors"
                        class="invalid-feedback">
                        <span *ngIf="chargeForm.get('chargesdetails.txtFuelAmt').errors.pattern">
                            Please enter a number with up to 12 digits and at most three decimal places.
                        </span>
                    </div> -->
                </div>
            </div>

            <div class="col-md-1">
                <div class="mb-2">
                    <label for="itemtax" class="form-label">Fuel Tax &nbsp;</label>
                    <div role="group" aria-label="Item fuel" class="btn-group btn-group-sm d-flex">
                        <input #btnradio1 type="radio" formControlName="chkFuelTax" id="btnradio1" autocomplete="off" checked=""
                            class="btn-check" value="Yes" (change)="calculateFuelTax(null, false, true)" 
                            (keydown.enter)="useEnterKey && btnradio2.focus()"/>
                        <label for="btnradio1" class="btn btn-outline-secondary">Yes</label>
                        <input #btnradio2 type="radio" formControlName="chkFuelTax" id="btnradio2" autocomplete="off"
                            class="btn-check" value="No" (change)="calculateFuelTax(null, false, true)" 
                            (keydown.enter)="useEnterKey && btntaxradio1.focus()"/>
                        <label for="btnradio2" class="btn btn-outline-secondary">No</label>
                    </div>
                </div>
            </div>

            <div class="col-md-1">
                <div class="mb-2">
                    <label for="fueltaxamt" class="form-label">Fuel Tax Amt</label>
                    <input #fueltaxamt type="number" class="form-control form-control-sm" id="fueltaxamt"
                        formControlName="txtFuelTaxAmount" />
                    <!-- <div *ngIf="(formSubmitted || chargeForm.get('chargesdetails.txtFuelTaxAmount')?.touched) && chargeForm.get('chargesdetails.txtFuelTaxAmount').errors"
                        class="invalid-feedback">
                        <span *ngIf="chargeForm.get('chargesdetails.txtFuelTaxAmount').errors.pattern">Please enter a
                            number with up to 5 digits and at most 3 decimal places.</span>
                    </div> -->
                </div>
            </div>

            <div class="col-md-1">
                <div class="mb-2">
                    <label for="tax" class="form-label">Tax &nbsp;</label>
                    <div role="group" aria-label="Tax" class="btn-group btn-group-sm d-flex">
                        <input #btntaxradio1 type="radio" formControlName="chkTax" id="btntaxradio1" autocomplete="off" checked=""
                            class="btn-check" value="Yes" (change)="calculateFuelTax(null, false, true)" 
                            (keydown.enter)="useEnterKey && btntaxradio2.focus()"/>
                        <label for="btntaxradio1" class="btn btn-outline-secondary">Yes</label>
                        <input #btntaxradio2 type="radio" formControlName="chkTax" id="btntaxradio2" autocomplete="off"
                            class="btn-check" value="No" (change)="calculateFuelTax(null, false, true)" 
                            (keydown.enter)="useEnterKey && itemtotal.focus()"/>
                        <label for="btntaxradio2" class="btn btn-outline-secondary">No</label>
                    </div>
                </div>
            </div>

            <div class="col-md-1">
                <div class="mb-2">
                    <label for="taxamt" class="form-label">Tax Amt</label>
                    <input #taxamt type="number" class="form-control form-control-sm" id="taxamt" formControlName="txtTaxAmount" />
                    <!-- <div *ngIf="(formSubmitted || chargeForm.get('chargesdetails.txtTaxAmount')?.touched) && chargeForm.get('chargesdetails.txtTaxAmount').errors" class="invalid-feedback">
                        <span *ngIf="chargeForm.get('chargesdetails.txtTaxAmount').errors.pattern">
                            Please enter a number with up to 12 digits and at most two decimal places.
                        </span>
                    </div> -->
                </div>
            </div>

            <div class="col-md-1">
                <div class="mb-2">
                    <label for="itemtotal" class="form-label">Item Total</label>
                    <input #itemtotal type="number" class="form-control form-control-sm" id="itemtotal"
                        formControlName="txtItemTotal" (keydown)="preventWrongInput($event)"
                        (keyup)="calculateReverseAmount()"
                        [ngClass]="{'is-invalid':(formSubmitted || chargeForm.get('chargesdetails.txtItemTotal')?.touched) && chargeForm.get('chargesdetails.txtItemTotal').errors}" 
                        (keydown.enter)="useEnterKey && chargeForm.get('chargesdetails.txtItemTotal').valid ? chargeSubmitBtn.focus() : chargeForm.get('chargesdetails.txtItemTotal').markAsTouched()"/>
                    <div *ngIf="(formSubmitted || chargeForm.get('chargesdetails.txtItemTotal')?.touched) && chargeForm.get('chargesdetails.txtItemTotal').errors" class="invalid-feedback">
                        <span *ngIf="chargeForm.get('chargesdetails.txtItemTotal').errors.pattern">
                            Please enter a number with up to 10 digits and at most 3 decimal places.
                        </span>
                    </div>
                    <div *ngIf="(formSubmitted || chargeForm.get('chargesdetails.txtItemAmount')?.touched) && chargeForm.get('chargesdetails.txtItemAmount').errors"
                        class="invalid-feedback">
                        <span *ngIf="chargeForm.get('chargesdetails.txtItemAmount').errors.required">
                            Item Amount is Required
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-md-2 mt-3">
                <div class="mb-2 mt-1">
                  <button #chargeSubmitBtn type="button" class="btn btn-primary btn-sm"  (keydown.enter)="upsertCharge()" (click)="upsertCharge()">{{ isChargesDetailsEdit ? 'Update' : 'Add' }}</button>
                  <button *ngIf="isChargesDetailsEdit" type="button" class="btn btn-secondary btn-sm" (click)="resetCharges(); getChargeValue()">Cancel</button>
                </div>
              </div>
        </div>
    </div>

    <div class="row mt-3" [style.display]="forwardingInfo ? 'none' : 'block'">
        <div class="col-md-12 grid-container">
            <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                [rowData]="customerRowData" [columnDefs]="columnDefs" [animateRows]="true" [context]="context"
                [defaultColDef]="defaultColDef" [gridOptions]="gridOptions" [suppressMenuHide]="true"
                [pagination]="true" (gridReady)="onGridReady($event)">
            </ag-grid-angular>
        </div>
    </div>

    <div class="row mt-3" [style.display]="forwardingInfo ? 'block' : 'none'">
        <div class="col-md-12 grid-container">
            <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                [rowData]="vendorRowData" [columnDefs]="columnDefs" [animateRows]="true" [context]="context"
                [defaultColDef]="defaultColDef" [gridOptions]="gridOptions" [suppressMenuHide]="true"
                [pagination]="true" (gridReady)="onGridReady($event)">
            </ag-grid-angular>
        </div>
    </div>
</form>